import { defineStore } from "pinia";

export const useToastLogStore = defineStore("toastLog", {
  state: () => ({
    logs: [],
  }),
  actions: {
    addToast(toast) {
      this.logs.push(toast);
      this.storeDataInLocalStorage("toasts", this.logs);
    },
    clearToastLog() {
      this.logs = [];
      localStorage.removeItem("toasts");
    },
    storeDataInLocalStorage(key, data) {
      const timestampedData = {
        timestamp: Date.now(),
        data: data,
      };
      localStorage.setItem(key, JSON.stringify(timestampedData));
    },
    getDataFromLocalStorage(key) {
      const item = localStorage.getItem(key);
      if (!item) return null;

      const { timestamp, data } = JSON.parse(item);
      const now = Date.now();
      const oneHour = 1000 * 60 * 60;

      if (now - timestamp < oneHour) {
        return data;
      } else {
        localStorage.removeItem(key);
        return null;
      }
    },
    init() {
      const storedLogs = this.getDataFromLocalStorage("toasts");
      if (storedLogs) {
        this.logs = storedLogs;
      }
    },
  },
});
const toastLogStore = useToastLogStore();
toastLogStore.init();
